export default {
    url: '/by_months',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 801,
        title: 'By months',
        role: 'arpu',
    },
    controller: [
        '$scope',
        '$location',
        'arpu_api',
        'chartFilters',
        function ($scope, $location, arpu_api, chartFilters) {
            $scope.data = {};
            $scope.ranges = {};
            $scope.gradient_colors = [
                '#ecf8ff',
                '#e7f6ff',
                '#e2f3ff',
                '#ddf1ff',
                '#d8efff',
                '#d3edff',
                '#ceeaff',
                '#c9e8ff',
                '#c4e6ff',
                '#bfe4ff',
                '#bae1ff',
                '#b5dfff',
                '#afddff',
                '#aadbff',
                '#a5d8ff',
                '#a0d6ff',
                '#9bd4ff',
                '#96d2ff',
                '#91cfff',
                '#8ccdff',
                '#87cbff',
                '#82c9ff',
                '#7dc6ff',
                '#78c4ff',
            ];
            $scope.update_arppu_table = function (model) {
                arpu_api.by_months(model).then(function (resp) {
                    $scope.data = resp;
                    $scope.calculate_ranges();
                });
            };
            $scope.calculate_ranges = function () {
                const data_keys = Object.keys($scope.data[0]);
                for (let key_i = 0; key_i < data_keys.length; key_i++) {
                    let values_list = [];
                    for (let i = 0; i < $scope.data.length; i++) {
                        values_list.push($scope.data[i][data_keys[key_i]]);
                    }
                    $scope.ranges[data_keys[key_i]] = {
                        min: Math.min.apply(Math, values_list),
                        max: Math.max.apply(Math, values_list),
                    };
                    $scope.ranges[data_keys[key_i]]['step'] =
                        ($scope.ranges[data_keys[key_i]]['max'] - $scope.ranges[data_keys[key_i]]['min']) /
                        ($scope.gradient_colors.length - 1);
                }
            };
            $scope.apply_color = function (value, key) {
                if (value !== 0) {
                    let position = Math.floor(
                        (value - $scope.ranges[key]['min']) / $scope.ranges[key]['step'],
                    );
                    return $scope.gradient_colors[position];
                }
            };
            $scope.apply = function (value) {
                return value === 0 ? '-' : value;
            };
            chartFilters.onChangeChartParams('update_arppu_table', $scope.update_arppu_table);
            $scope.update_arppu_table(chartFilters.get_chart_filters());
        },
    ],
};
